module.exports = __webpack_public_path__ + "media/images/icon__betPick--none@2x-bad96e81e153e576453fec2dfbdc59fb.png";